import { apiService } from '../../../shared/services/apiServices';
import technicianEndpoints from './technicianEndpoints';
import { TECHNICIAN_ERROR_MESSAGES } from '../errors/errorMessages';

export interface PresignedUrlBatchRequest {
  paths: string[];
  generatePath?: boolean;
}

export interface PresignedUrlBatchResponse {
  entityId?: string;
  files: Array<{
    originalPath: string;
    path: string;
    url: string;
    resourceId: string;
  }>;
}

export const getPresignedUrlsBatch = async (
  request: PresignedUrlBatchRequest
): Promise<PresignedUrlBatchResponse> => {
  try {
    const result = await apiService.postAPI(
      technicianEndpoints.PRESIGNED_URLS_BATCH,
      request
    );

    if (result.error) {
      throw new Error(TECHNICIAN_ERROR_MESSAGES.UNEXPECTED_ERROR);
    }

    return result.data as PresignedUrlBatchResponse;
  } catch (_error) {
    throw new Error(TECHNICIAN_ERROR_MESSAGES.UNEXPECTED_ERROR);
  }
};
